import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { EHeadAlign } from '@domain/enums/components/ETable';

import * as S from './styles';

const SkeletonLoading: React.FC = () => {
  return (
    <>
      <S.ProductCostTable.Row borderBottom>
        <S.ProductCostTable.Data>
          <S.ProductDetailsWrapper>
            <Skeleton width={48} height={48} style={{ borderRadius: '50%' }} />
            <Skeleton width={120} height={27} />
          </S.ProductDetailsWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data>
          <S.ProviderWrapper>
            <Skeleton width={126} height={42} style={{ borderRadius: 5 }} />
          </S.ProviderWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.RIGHT}>
          <Skeleton width={64} height={27} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={102} height={42} style={{ borderRadius: 5 }} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={28} height={28} />
        </S.ProductCostTable.Data>
      </S.ProductCostTable.Row>

      <S.ProductCostTable.Row borderBottom>
        <S.ProductCostTable.Data>
          <S.ProductDetailsWrapper>
            <Skeleton width={48} height={48} style={{ borderRadius: '50%' }} />
            <Skeleton width={120} height={27} />
          </S.ProductDetailsWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data>
          <S.ProviderWrapper>
            <Skeleton width={126} height={42} style={{ borderRadius: 5 }} />
          </S.ProviderWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.RIGHT}>
          <Skeleton width={64} height={27} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={102} height={42} style={{ borderRadius: 5 }} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={28} height={28} />
        </S.ProductCostTable.Data>
      </S.ProductCostTable.Row>

      <S.ProductCostTable.Row borderBottom>
        <S.ProductCostTable.Data>
          <S.ProductDetailsWrapper>
            <Skeleton width={48} height={48} style={{ borderRadius: '50%' }} />
            <Skeleton width={120} height={27} />
          </S.ProductDetailsWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data>
          <S.ProviderWrapper>
            <Skeleton width={126} height={42} style={{ borderRadius: 5 }} />
          </S.ProviderWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.RIGHT}>
          <Skeleton width={64} height={27} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={102} height={42} style={{ borderRadius: 5 }} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={28} height={28} />
        </S.ProductCostTable.Data>
      </S.ProductCostTable.Row>

      <S.ProductCostTable.Row borderBottom>
        <S.ProductCostTable.Data>
          <S.ProductDetailsWrapper>
            <Skeleton width={48} height={48} style={{ borderRadius: '50%' }} />
            <Skeleton width={120} height={27} />
          </S.ProductDetailsWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data>
          <S.ProviderWrapper>
            <Skeleton width={126} height={42} style={{ borderRadius: 5 }} />
          </S.ProviderWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.RIGHT}>
          <Skeleton width={64} height={27} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={102} height={42} style={{ borderRadius: 5 }} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={28} height={28} />
        </S.ProductCostTable.Data>
      </S.ProductCostTable.Row>

      <S.ProductCostTable.Row borderBottom>
        <S.ProductCostTable.Data>
          <S.ProductDetailsWrapper>
            <Skeleton width={48} height={48} style={{ borderRadius: '50%' }} />
            <Skeleton width={120} height={27} />
          </S.ProductDetailsWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data>
          <S.ProviderWrapper>
            <Skeleton width={126} height={42} style={{ borderRadius: 5 }} />
          </S.ProviderWrapper>
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.RIGHT}>
          <Skeleton width={64} height={27} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={102} height={42} style={{ borderRadius: 5 }} />
        </S.ProductCostTable.Data>

        <S.ProductCostTable.Data align={EHeadAlign.CENTER}>
          <Skeleton width={28} height={28} />
        </S.ProductCostTable.Data>
      </S.ProductCostTable.Row>
    </>
  );
};

export default SkeletonLoading;
